// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zjMh","question":"styles_question__2Qa1A","description":"styles_description__E-EM9"};